import React, { useEffect, useState } from 'react';
import "moment/locale/de";
import { ReviewDetailsMobComponent } from '../review-details-mob/review-details-mob.component';
import { TaskDetailsMobComponent } from '../task-details-mob/task-details-mob.component';
import { ReviewsService } from 'src/services/reviews/reviews.service';

export default function RatingsMob(props: any) {
  const emptyObj: any = {};
  const { taskData } = props;
  const { recordTaskId } = taskData;
  const [review, setReview] = useState(emptyObj);
  const reviewsService = new ReviewsService();
  const [loading, setLoading] = useState(true);

  async function fetchData() {
    setLoading(true);
    const rating = await reviewsService.getReviewByRecordTaskId(recordTaskId);
    setReview(rating)
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <TaskDetailsMobComponent
        data={taskData}
        loading={loading}
      />
      <ReviewDetailsMobComponent 
        review={review}
        taskData={taskData}
        loading={loading}
      />
    </>
  );
}
